import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { auth, googleProvider, microsoftProvider } from './sso/fire';
import { signInWithPopup } from 'firebase/auth';
import { ASSISTANT_URL, ASSISTANT_AUTH_REGISTER_URL } from '../constants';

const Register = () => {
    const [formData, setFormData] = useState({ username: '', email: '', password: '' });
    const [error, setError] = useState(null);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!formData.username || !formData.email || !formData.password) {
            setError('Todos los campos son obligatorios');
            return;
        }

        try {
            const res = await axios.post(ASSISTANT_AUTH_REGISTER_URL, formData, { withCredentials: true });

            if (res.data.token) {
                login(res.data.token, res.data.username);
                navigate(`/dashboard?nom=${encodeURIComponent(res.data.username)}`);
            } else {
                setError('Registro fallido. Intenta nuevamente.');
            }
        } catch (err) {
            console.error('Error en registro:', err);
            setError(err.response?.data?.msg || 'Ocurrió un error. Intenta nuevamente.');
        }
    };

    const handleSocialSignIn = async (provider) => {
        try {
            const result = await signInWithPopup(auth, provider);
            const token = await result.user.getIdToken();

            const res = await axios.post(
                `${ASSISTANT_URL}/api/auth/${provider === googleProvider ? 'google' : 'microsoft'}`,
                { token },
                { withCredentials: true }
            );

            if (res.data.token) {
                login(res.data.token);
                navigate('/dashboard');
            } else {
                setError(`${provider === googleProvider ? 'Google' : 'Microsoft'} falló. Intenta nuevamente.`);
            }
        } catch (error) {
            console.error('Error en autenticación social:', error);
            setError(`${provider === googleProvider ? 'Google' : 'Microsoft'} falló. Intenta nuevamente.`);
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg">
                <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">Crear cuenta</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Nombre de usuario</label>
                        <input
                            type="text"
                            name="username"
                            placeholder="Tu nombre"
                            value={formData.username}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="tucorreo@ejemplo.com"
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Contraseña</label>
                        <input
                            type="password"
                            name="password"
                            placeholder="••••••••"
                            value={formData.password}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Registrarse
                    </button>
                </form>

                {/* Botones ocultos (por implementar más adelante) */}
                <div className="hidden mt-4">
                    <button
                        onClick={() => handleSocialSignIn(googleProvider)}
                        className="w-full bg-red-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        Iniciar sesión con Google
                    </button>
                </div>

                <div className="hidden mt-4">
                    <button
                        onClick={() => handleSocialSignIn(microsoftProvider)}
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Iniciar sesión con Microsoft
                    </button>
                </div>

                <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                        ¿Ya tienes una cuenta?
                        <Link to="/login" className="text-indigo-600 hover:underline"> Inicia sesión</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Register;
